import VGInputMask from "./inputmask";
import {onReady} from "../../../../modules/vegas/js/util";

function enableInputmask() {
	new VGInputMask().init();
}

onReady(enableInputmask);
typeof onTurboRender !== 'undefined' && onTurboRender(enableInputmask);

